import {ValidatorFn, AbstractControl } from '@angular/forms';
import { isMultiParams } from '../../utils/helpers';


export const CustomValidateRequiredLocation = (options: any): ValidatorFn => {

  const message = 'This value must contain parameters';


  return (control: AbstractControl): any => {

    try {
      let attributes = [];
      let valid = true;
      let missingAttributes = [];

      if (!control.value) {
        return null;
      }

      if (typeof options === 'string') {
        attributes = isMultiParams(options);
      }

      if (typeof control.value === 'object') {

        missingAttributes = [];
        valid = true;

        attributes.forEach(element => {
          if (!control.value[element]) {
            valid = false;
            missingAttributes.push(element);
          } else {
            if (!control.value[element].toString().length) {
              valid = false;
              missingAttributes.push(element);
            }
          }
        });

        if (valid) {
          return null;
        }
      } else {
        missingAttributes = attributes;
      }

      return {
        invalidRequiredLocation: true,
        message: `${message} "${missingAttributes.join(',')}"`
      };
    } catch (error) {
      return {
        invalidValidation: true,
        message: `Error validating the field`
      };
    }


  };
};



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/components/required-location/required-location.validator.ts